import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import style from './styles/style.module.css';
import { Field, reduxForm, Form } from 'redux-form';
import { PrimaryButton } from 'appSrc/components/UI';
import { FormTextField } from 'appSrc/components/UI/ReduxForm';
import { validateWebUrl, validateSlug } from 'appSrc/utils';

const validate = {
    required: ( value ) => ( ( value == null || !/\S/.test( value ) ) ? 'Required' : undefined ),
    path: ( value ) => ( !validateSlug( value ) ? 'Can only contain letters, numbers, hyphens, and underscores': undefined ),
    url: ( value ) => ( !validateWebUrl( value ) ? 'Must be a complete URL' : undefined ),
};

class VanityLinkForm extends PureComponent {
    constructor(props) {
        super(props);
    }
    submit = ( values ) => {
        var data = { ...values };
        data.vanity_url_path = '/' + data.vanity_url_path;
        this.props.onSubmit( data );
    }
    render() {
        const { handleSubmit, valid } = this.props;
        return (
            <Form
            className={ style.tagForm }
            onSubmit={ handleSubmit( this.submit ) }>
                <Field
                name="vanity_url_path"
                label="Vanity Path"
                internalLabel={ process.env.VANITY_HOST + '/' }
                placeholder='vanity_path'
                component={ FormTextField }
                validate={ [ validate.required, validate.path ] }
                required
                autoFocus
                fullWidth />

                <Field
                name="redirect_url"
                label="Destination URL"
                placeholder='https://thedesirecompany.com/brianisthebest/briansbestlist'
                component={ FormTextField }
                validate={ [ validate.required, validate.url ] }
                required
                fullWidth />

                <PrimaryButton
                label="Submit"
                fullWidth
                type="submit"
                disabled={ !valid }
                style={ { marginTop: '15px' } }/>
            </Form>
        );
    }
}

VanityLinkForm = reduxForm( {
    form: 'VanityLinkForm',
} )( VanityLinkForm );


export default connect()( VanityLinkForm );
